import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import TextArea from 'components/shared/debouncedTextArea';
import { updateParamQuery } from 'actions/assign';
import { Icon } from 'ui';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: false,
    };
    this.toggleFilters = this.toggleFilters.bind(this);
  }

  toggleFilters() {
    const VISIBLE_CLASS = 'is-visible';
    const { getFiltersRef } = this.props;
    const filtersRef = getFiltersRef();
    filtersRef.classList.toggle(VISIBLE_CLASS);
    this.setState({
      toggleActive: filtersRef.classList.contains(VISIBLE_CLASS),
    });
  }

  render() {
    const { placeholder, updateQuery } = this.props;
    const filterToggleClassNames = classNames('AssignModal-toggleFiltersBtn', {
      'u-showBelowXS': true,
      'AssignModal-toggleFiltersBtn--active': this.state.toggleActive,
    });

    return (
      <div className="AssignModal-searchBox">
        <TextArea
          className="AssignModal-searchInput"
          placeholder={placeholder}
          onChange={updateQuery}
          value={this.props.value}
          singleLine
          controlled
          maxLength={255}
        />
        <button
          type="button"
          className={filterToggleClassNames}
          onClick={this.toggleFilters}
        >
          <Icon name="filter" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  value: state.params.query,
});

const mapDispatchToProps = dispatch => ({
  updateQuery(value) {
    dispatch(updateParamQuery(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);
